import React from 'react'
import {
    Card,
    CardBody,
    CardHeader,
    CardTitle,
    GridContainer,
    GridItem,
} from '@fabricks/ui-components'
import { Skeleton } from '@material-ui/lab'
import { useKeycloak } from 'react-keycloak'
import DeepInsight from './DeepInsight/DeepInsight'

interface DeepInsightsPageProps {}

export const DeepInsights: React.FC = (props: DeepInsightsPageProps) => {
    const [keycloak] = useKeycloak()

    if (true) {
        return (
            <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                    <Card className="card graph">
                        <CardHeader color="primary" isStats={false} type="plain">
                            <CardTitle color="white" align="center" title="Deep Insights" variant="h5" />
                        </CardHeader>
                        <CardBody align="center" isProfile>
                            <DeepInsight />
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>
        )
    }
    return (
        <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
                <Card>
                    <Skeleton variant="text" animation="wave" />
                    <Skeleton variant="rect" animation="wave" width={210} height={118} />
                </Card>
            </GridItem>
        </GridContainer>
    )
}
